module.exports = __webpack_public_path__ + "static/assets/db9204a5e2a316eff79c995b4c719ddc.gif";